// @flow
import React from 'react'
import Button from '@material-ui/core/Button'
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'
import MobileStepper from '@material-ui/core/MobileStepper'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import SwipeableViews from 'react-swipeable-views'
import { withStyles } from '@material-ui/core/styles'
import BaseLayerStyles from 'catena/er2_styles/baselayers'

type BaseLayerType = {
    classes: {
        root: string,
        header: string,
        img: string,
        mobileStepper: string,
    },
    name: string,
    value: string,
    imageSrc: string,
    theme: BaseLayerStyles,
}

const styles = theme => ({
    root: {
        maxWidth: 400,
        flexGrow: 1,
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        height: 50,
        paddingLeft: theme.spacing.unit * 4,
        marginBottom: 20,
        backgroundColor: theme.palette.background.default,
    },
    img: {
        height: 255,
        maxWidth: 400,
        overflow: 'hidden',
        width: '100%',
    },
})

class BaseLayerPanel extends React.Component<BaseLayerType> {
    constructor(props) {
        super(props)
        const baseLayerName = this.props.baseLayer ? this.props.baseLayer.get('baseLayerName') : null
        let activeStep = this.props.baseLayerChoices.findIndex(c => c.name === baseLayerName)
        if (activeStep < 0) {
            activeStep = 0
        }
        this.state = {
            activeStep,
        }
    }

    render() {
        const { activeStep } = this.state
        const maxSteps = this.props.baseLayerChoices.length

        const setBaseLayer = (baseLayer: string) => {
            this.props.onSetBaseLayer(baseLayer)
        }

        const handleNext = () => {
            const nextStep = this.state.activeStep + 1
            this.setState({ activeStep: nextStep })
            setBaseLayer(this.props.baseLayerChoices[nextStep].name)
        }

        const handleBack = () => {
            const prevStep = this.state.activeStep - 1
            this.setState({ activeStep: prevStep })
            setBaseLayer(this.props.baseLayerChoices[prevStep].name)
        }

        const handleStepChange = (newActiveStep) => {
            this.setState({ activeStep: newActiveStep })
            setBaseLayer(this.props.baseLayerChoices[newActiveStep].name)
        }

        return (
            <div className={this.props.classes.root}>
                <Paper square elevation={0} className={this.props.classes.header}>
                    <Typography>{this.props.baseLayerChoices[activeStep].name}</Typography>
                </Paper>
                <SwipeableViews
                    axis={this.props.theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                    index={activeStep}
                    onChangeIndex={(activeStep) => handleStepChange(activeStep)}
                    enableMouseEvents
                >
                    {this.props.baseLayerChoices.map(step => (
                        <img key={step.name} className={this.props.classes.img} src={`${this.props.baseImageURL}/${step.imageSrc}`} alt={step.name} />
                    ))}
                </SwipeableViews>
                <MobileStepper
                    steps={maxSteps}
                    position="static"
                    activeStep={activeStep}
                    className={this.props.classes.mobileStepper}
                    nextButton={
                        <Button size="small" onClick={() => handleNext()} disabled={activeStep === maxSteps - 1}>
                            Next
                            <KeyboardArrowRight />
                        </Button>
                    }
                    backButton={
                        <Button size="small" onClick={() => handleBack()} disabled={activeStep === 0}>
                            <KeyboardArrowLeft />
                            Back
                        </Button>
                    }
                />
            </div>
        )
    }
}

BaseLayerPanel.defaultProps = {
    theme: styles,
}

export default withStyles(styles, { withTheme: true })(BaseLayerPanel)
